import React from 'react';
import { Row } from 'antd';
import { OutStandingInvoiceBanner } from '@sharedComponent/banner';
import { AmountBalanceCard, GaugeChartsCard, CutOffTimingsCard } from '../cards';

const DashboardFirstSection = ({
	currentUser,
	employeeCount,
	isEmployeeCountLoading,
	corporateDetails,
	invoiceFlag,
}) => {

	return (
		<section className="main_dashboard_web_first_row fade-right">
			{invoiceFlag && <OutStandingInvoiceBanner />}
			<Row>
				<AmountBalanceCard />
				<GaugeChartsCard {...{ employeeCount, isEmployeeCountLoading }} />
				<CutOffTimingsCard {...{ currentUser, corporateDetails }} />
			</Row>
		</section>
	);
};

export default DashboardFirstSection;
